(ns frontend.ui.page.lp-report-editor.common.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color text-size]]
   [garden.units :refer [px]]
   [garden.util :refer [space-join]]))

(defn footer-container
  []
  {:display         "flex"
   :flex            "0 0 auto"
   :justify-content "space-between"
   :align-items     "center"
   :padding         "16px"
   :z-index         "101"
   :background      (theme/color [:lp-editor :page :background])
   ;:box-shadow       (space-join ["0" "0" "6px" (color [:footer-bgr :primary :border])])
  })

(defn footer-left
  []
  ^{:media {{:screen :only :max-width (px 1200)}
            {:gap "8px"}}}
  {:display "flex"
   :flex    "1 1 auto"
   :justify-content "start"
   :gap     "16px"})

(defn footer-right
  []
  {:display "flex"
   :flex    "1 1 auto"
   :justify-content "end"
   :gap     "16px"})


(defn spacing-top-bottom
  []
  {:padding-top    "16px"
   :padding-bottom "16px"})

(defn spacing
  []
  {:padding "16px"})


(defn spacing-left
  []
  ^{:media {{:screen :only :max-width (px 1200)}
            {:margin-left "8px"}}}
  {:display     "inline-block"})

(defn spacing-right
  []
  {:display      "inline-block"})

(defn spacing-top
  []
  {:display    "block"
   :margin-top "16px"
   :width      "100%"})

(defn text-uppercase
  []
  {:display        "block"
   :padding-bottom ".5rem"
   :font-weight    "bold"
   :text-transform "uppercase"
   :font-size      ".725rem"})

(defn section-border-top
  []
  {:margin-top  "1rem"
   :padding-top "1rem"
   :border-top  (space-join ["1px" "solid" (color [:alert :border])])})

(defn icon-step
  []
  {:margin-right "12px"
   :font-size    (text-size :medium :size)
   :color        (theme/color [:lp-editor :step :icon :default])})

(defn icon-step-done
  []
  {:margin-right "12px"
   :font-size    (text-size :medium :size)
   :color        (theme/color [:lp-editor :step :icon :done])})

(defn sidebar-nav
  []
  {:display    "flex"
   :font-size  (text-size :medium :size)
   :position   "sticky"
   :top        "0"
   :background "#fff"
   :z-index    "100"
   :overflow   "auto"
   :box-shadow "0 0 4px rgba(0,0,0,.15)"})

(defn sidebar-nav-link
  []
  (with-meta
    {:display        "flex"
     :padding        "1.25rem"
     :font-size      (text-size :xxsmall :size)
     :color          (theme/color [:lp-editor :sidebar-nav-link :default])
     :text-transform "uppercase"
     :font-weight    "bold"
     :letter-spacing "2px"}
    {:pseudo
     {:hover
      {:color (theme/color [:lp-editor :sidebar-nav-link :hover])}}}
  ))

(defn table-wrapper
  []
  {:overflow "auto"})

(defn table-cursor-pointer
  []
  {:cursor "pointer"})



(defn upload-files-header
  []
  {:display       "flex"
   :margin-bottom "8px"
   :padding       "0 8px"})

(defn upload-file-name
  []
  {:width       "45%"
   :padding     "8px"
   :font-weight "bold"})

(defn upload-file-status
  []
  {:width       "25%"
   :padding     "8px"
   :font-weight "bold"})

(defn upload-file-progress
  []
  {:width       "30%"
   :padding     "8px"
   :font-weight "bold"})

(defn upload-file-item
  "Card for one file: the columns line, and any error alert under it."
  []
  {:padding       "8px 12px"
   :margin-bottom "8px"
   :box-shadow    "0 0 8px rgba(0,0,0,.15)"
   :border-radius "8px"
   :font-size     (text-size :small :size)})

(defn upload-file-item-columns
  []
  {:display "flex"})

(defn upload-file-item-name
  []
  {:width       "45%"
   :padding     "8px 8px"
   :word-break  "break-word"
   :font-weight "600"
   :font-size   (text-size :xsmall :size)})

(defn upload-file-item-size
  []
  {:display   "flex"
   :padding   "4px 0 0"
   :color     (theme/color [:lp-editor :upload :default])
   :font-size (text-size :xxxsmall :size)})

(defn upload-file-item-progress
  []
  {:width   "30%"
   :padding "8px 8px"})

(defn upload-file-item-status
  [status]
  {:width       "25%"
   :font-size   (text-size :xsmall :size)
   :font-weight "600"
   :padding     "8px 8px"
   :color       (case status
                  :uploading (theme/color [:lp-editor :upload :uploading])
                  :error (theme/color [:lp-editor :upload :error])
                  :processing (theme/color [:lp-editor :upload :processing])
                  :complete (theme/color [:lp-editor :upload :complete])
                  "inherit")})

(defn progress
  []
  {:margin-top    "4px"
   :background    (theme/color [:lp-editor :upload :progress])
   :border-radius "16px"})

(defn progress-bar
  [percentage]
  {:width         (str (or percentage 0) "%")
   :padding       "0 4px"
   :border-radius "16px"
   :text-align    "center"
   :color         (theme/color [:lp-editor :upload :progress-bar :text])
   :background    (theme/color [:lp-editor :upload :progress-bar :background])
   :font-size     (text-size :xxxsmall :size)})

(defn import-progress
  "Unlabelled track for a single import; sized here since nothing fills it."
  []
  {:margin-top    "4px"
   :height        "8px"
   :overflow      "hidden"
   :background    (theme/color [:lp-editor :upload :progress])
   :border-radius "16px"})

(defn import-progress-bar
  "Fill for one import; `status` colours a failed one."
  [status percentage]
  {:width         (str (or percentage 0) "%")
   :height        "100%"
   :border-radius "16px"
   ;; Transition keeps stepped progress from looking stalled.
   :transition    "width 300ms ease-out"
   :background    (if (= status :error)
                    (theme/color [:lp-editor :upload :error])
                    (theme/color [:lp-editor :upload :progress-bar :background]))})

(defn no-content
  []
  {:display         "flex"
   :flex-flow       "column"
   :justify-content "center"
   :align-items     "center"
   :gap             "16px"})
